export const nameSpace = '@@/promo-code';
